module.exports = __webpack_public_path__ + "static/img/success.571caab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success.png
// module id = 4AGf
// module chunks = 1